module.exports = __webpack_public_path__ + "2b0fe529632ea8765fe2800bc138e84c.pdf";